import { apiService } from "@/core/api";
import { API_ENDPOINTS } from "@/core/constants/endpoints";

export class ReCaptchaV3ValidationService {
  async recaptchaV3Validation(
    formData: any,
    recaptchaToken: string,
  ): Promise<any> {
    try {
      const response = await apiService.post<{
        formData: any;
        recaptchaToken: string;
      }>(API_ENDPOINTS.RECAPTCHA.VALIDATE, { formData, recaptchaToken });
      return response;
    } catch (error) {
      console.error("Error validating reCAPTCHA token:", error);
      return false;
    }
  }
}
export const reCaptchaV3ValidationService = new ReCaptchaV3ValidationService();
